module.exports = __webpack_public_path__ + "img/okVideo.9a39d33a.png";